import { render } from "./HeroiconsOutlineSupport.vue?vue&type=template&id=6107879f"
const script = {}

import exportComponent from "/var/www/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSupport.vue"]])

export default __exports__